export default {
	namespaced: true,
	state: {
		popups: []
	},
	getters: {
		popups:	state => state.popups
	},
	actions: {
		push(c, popup) {
			c.commit('PUSH', popup);
		},
		replace(c, { popup, level = 0 }) {
			c.commit('REPLACE', {
				popup: popup,
				level: level
			});
		},
		pop(c) {
			c.commit('POP');
		},
		clear(c) {
			c.commit('CLEAR');
		}
	},
	mutations: {
		PUSH(state, pop) {
			state.popups.push(pop);
		},
		REPLACE(state, { popup, level }) {
			state.popups = state.popups.splice(0, level);
			state.popups.push(popup);
		},
		POP(state) {
			state.popups.pop();
		},
		CLEAR(state) {
			state.popups = [];
		}
	}
};